<template>
  <div class="file-download-page">
    <div class="desktop-page" v-if="!this.GLOBAL.isMobile">
      <div class="wrap">
        <section class="page-head">
          <div class="head-row">
            <div class="tabs category-tabs">
              <button
                v-for="fileType in fileTypeList"
                :key="fileType.id"
                type="button"
                :class="{ active: checkedFileType === fileType.id }"
                @click="onClickFileType(fileType.id)"
              >
                {{ fileType.name }}
              </button>
            </div>
            <div class="search-row">
              <div class="search-box">
                <el-input
                  v-model="searchValue"
                  :placeholder="$t('text1')"
                  class="download-search"
                  @keyup.enter.native="handleSearch"
                >
                  <button slot="suffix" type="button" class="search-trigger" @click="handleSearch">
                    <i class="el-icon-search"></i>
                  </button>
                </el-input>
              </div>
            </div>
          </div>
        </section>

        <section class="download-list">
          <div v-for="file in filePageList" :key="file.uuid" class="file-row">
            <a target="_blank" class="file-link" :href="cp + '/jyy/portal/getFile?uuid=' + file.uuid">
              {{ file.billFileName }}
            </a>
            <div class="file-time">{{ file.createTime }}</div>
          </div>
        </section>

        <div class="pagination-wrap">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :pager-count="11"
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div id="productListDiv" class="mobile-page" v-if="this.GLOBAL.isMobile" @touchmove="isShow">
      <div class="wrap">
        <section class="page-head mobile-head">
          <div class="tabs category-tabs mobile-tabs">
            <button
              v-for="fileType in fileTypeList"
              :key="fileType.id"
              type="button"
              :class="{ active: checkedFileType === fileType.id }"
              @click="onClickFileType(fileType.id)"
            >
              {{ fileType.name }}
            </button>
          </div>
          <div class="search-row mobile-search-row">
            <div class="search-box mobile-search-box">
              <el-input
                v-model="searchValue"
                :placeholder="$t('text1')"
                class="download-search"
                @keyup.enter.native="handleSearch"
              >
                <button slot="suffix" type="button" class="search-trigger" @click="handleSearch">
                  <i class="el-icon-search"></i>
                </button>
              </el-input>
            </div>
          </div>
        </section>

        <section class="download-list mobile-list">
          <div v-for="file in filePageList" :key="file.uuid" class="file-row mobile-file-row">
            <a target="_blank" class="file-link" :href="cp + '/jyy/portal/getFile?uuid=' + file.uuid">
              {{ file.billFileName }}
            </a>
            <div class="file-time">{{ shortTimeDot(file.createTime) }}</div>
          </div>
        </section>

        <div id="getMoreDiv" class="load-more-wrap">
          <div v-if="total > page * pageSize" class="load-more">{{ $t('text2') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPageParamStr} from '@/utils/utils'
import axios from '@/utils/axios'
import {shortTimeDot} from '../../utils/dateFormat'

export default {
  data() {
    return {
      cp: this.GLOBAL.cp,
      page: 1,
      pageSize: 10,
      total: 0,
      searchValue: '',
      fileTypeList: [],
      checkedFileType: '',
      fileDownloadTypeList: [],
      filePageList: [],
      loading: false,
    }
  },
  mounted() {
    this.initFileType()
  },
  methods: {
    shortTimeDot,
    initFileType() {
      axios.get('/jyy/portal/getDictList?type=FILE_DOWNLOAD').then(res => {
        this.fileTypeList = res.data
        if (this.fileTypeList.length) {
          this.checkedFileType = this.fileTypeList[0].id
          this.initPageList()
        }
      })
    },
    handleSearch() {
      this.page = 1
      this.filePageList = []
      this.initPageList()
    },
    initPageList(isClearPageList) {
      this.loading = true
      const searchValue = encodeURIComponent(this.searchValue)
      const url = '/jyy/portal/selectFileDownloadPage?searchValue=' + searchValue +
        '&fileType=' + this.checkedFileType +
        getPageParamStr(this.page, this.pageSize)
      axios.get(url).then(res => {
        this.page = res.data.page
        this.pageSize = res.data.pageSize
        this.total = res.data.total
        if (isClearPageList === '0') {
          this.filePageList = this.filePageList.concat(res.data.rows)
        } else {
          this.filePageList = res.data.rows
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onClickFileType(fileType) {
      if (fileType != null && fileType !== '' && this.checkedFileType !== fileType) {
        this.checkedFileType = fileType
      }
      this.page = 1
      this.filePageList = []
      this.initPageList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.initPageList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.initPageList()
    },
    isShow() {
      const element = document.getElementById('getMoreDiv')
      if (!element) {
        return
      }
      const innerHeight = window.innerHeight
      const clientHeight = element.clientHeight
      const {top} = element.getBoundingClientRect()
      if (top < innerHeight - clientHeight + 100 && !this.loading && this.total > this.page * this.pageSize) {
        this.page = this.page + 1
        this.initPageList('0')
      }
    },
  },
}
</script>

<style scoped>
.file-download-page {
  min-height: 800px;
  background: linear-gradient(180deg, #f9fbff 0%, #f4f8fe 100%);
  color: #111c2d;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.wrap {
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
}

.desktop-page {
  padding: 72px 0 64px;
}

.mobile-page {
  padding: 76px 0 44px;
}

.page-head {
  padding-bottom: 8px;
}

.head-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 24px;
  align-items: center;
  padding-bottom: 18px;
  border-bottom: 1px solid #dbe4ef;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0;
}

.tabs button {
  position: relative;
  min-height: 44px;
  padding: 0 24px 12px;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #8a9ab0;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
  transition: color 0.22s ease;
}

.tabs button::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #09aeff 0%, #72f7b1 100%);
  transition: width 0.2s linear;
}

.tabs button:hover,
.tabs button.active {
  color: #0a3569;
  font-weight: 600;
}

.tabs button:hover::after,
.tabs button.active::after {
  width: 100%;
}

.category-tabs {
  padding-bottom: 18px;
  border-bottom: 1px solid #dbe4ef;
}

.search-row {
  padding-top: 18px;
}

.head-row .category-tabs {
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;
  padding-bottom: 0;
  border-bottom: none;
    margin-bottom: 0px;
}

.head-row .search-row {
  padding-top: 0;
}

.search-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.download-search {
  width: 260px;
  max-width: 100%;
}

.download-search ::v-deep .el-input__inner {
  height: 40px;
  padding-left: 14px;
  padding-right: 42px;
  border: 1px solid #d1dbe8;
  border-radius: 8px;
  background: #ffffff;
  color: #111c2d;
  transition: border-color 0.22s ease, box-shadow 0.22s ease;
}

.download-search ::v-deep .el-input__inner:focus {
  border-color: #0a3569;
  box-shadow: 0 0 0 3px rgba(10, 53, 105, 0.08);
}

.download-search ::v-deep .el-input__suffix {
  right: 8px;
  display: flex;
  align-items: center;
  height: 100%;
}

.download-search ::v-deep .el-input__suffix-inner {
  display: flex;
  align-items: center;
}

.search-trigger {
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #0a3569;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.22s ease, color 0.22s ease;
}

.search-trigger:hover {
  background: rgba(10, 53, 105, 0.08);
}

.download-list {
  padding-top: 28px;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 0;
  border-bottom: 1px solid #e9eff6;
}

.file-link {
  color: #111c2d;
  font-size: 16px;
  line-height: 1.7;
  text-decoration: none;
  word-break: break-all;
}

.file-link:hover {
  color: #184d93;
}

.file-time {
  flex-shrink: 0;
  color: #7d899b;
  font-size: 14px;
}

.pagination-wrap {
  padding-top: 34px;
  text-align: center;
}

.pagination-wrap ::v-deep .btn-prev,
.pagination-wrap ::v-deep .btn-next,
.pagination-wrap ::v-deep .el-pager li {
  min-width: 34px;
  height: 34px;
  line-height: 34px;
  border: none;
  background: transparent;
  color: #8a9ab0;
  font-weight: 400;
}

.pagination-wrap ::v-deep .el-pager li.active,
.pagination-wrap ::v-deep .btn-prev:hover,
.pagination-wrap ::v-deep .btn-next:hover,
.pagination-wrap ::v-deep .el-pager li:hover {
  color: #0a3569;
  font-weight: 600;
}

.mobile-head {
  padding-bottom: 14px;
}

.mobile-tabs {
  justify-content: flex-start;
}

.mobile-search-row {
  padding-top: 14px;
}

.mobile-search-box {
  justify-content: stretch;
}

.mobile-search-box .download-search {
  width: 100%;
}

.mobile-list {
  padding-top: 18px;
}

.mobile-file-row {
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
}

.load-more-wrap {
  padding-top: 22px;
  padding-bottom: 100px;
}

.load-more {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 1px solid #d1dbe8;
  border-radius: 8px;
  color: #0a3569;
  font-size: 14px;
  font-weight: 600;
  background: #ffffff;
}

@media (max-width: 640px) {
  .wrap {
    width: calc(100% - 24px);
  }

  .tabs button {
    padding: 0 16px 10px;
    font-size: 14px;
  }
}

@media (max-width: 900px) {
  .head-row {
    grid-template-columns: 1fr;
    align-items: center;
  }

  .head-row .search-box {
    justify-content: flex-start;
  }
}
</style>
